import { useContext } from "react";
import themeContext from "../../themeContext/themeContext";

import Header from "../Header";
import AboutSection from "../AboutSection";
import ContactSection from "../ContactSection";
import VideoContainer from "../VideoContainer";
import Footer from "../Footer";

import { MdKeyboardDoubleArrowUp } from "react-icons/md";

import {
  HeroSection,
  InfoContainer,
  MainContainer,
  PersonName,
  RoleNote,
  ScrollUp,
  Protiop,
} from "./styledComponents";

function Home() {
  const { isDarkMode } = useContext(themeContext);

  return (
    <>
      <Header />
      {/* Main */}
      <MainContainer isDarkMode={isDarkMode}>
        {/* Hero Section */}
        <HeroSection id="hero">
          <InfoContainer>
            <PersonName>Hi,👋</PersonName>
            <RoleNote>
              Welcome! We're thrilled to have you here. Take the first step
              towards exciting career opportunities by filling out your details
              below. Let's embark on this journey together towards finding the
              perfect match for your skills and aspirations.
            </RoleNote>
            <Protiop>
              *Pro Tip:- Use this site on a laptop for a better experience and
              understanding.
            </Protiop>
          </InfoContainer>
        </HeroSection>
      </MainContainer>

      {/* Video Container */}

      <AboutSection />
      <VideoContainer isDarkMode={isDarkMode} id="Intro"/>
      <ContactSection />
      <Footer />
      <ScrollUp aria-label="scroll-up" href="#" isDarkMode={isDarkMode}>
        <MdKeyboardDoubleArrowUp
          style={{
            color: isDarkMode ? "#fff" : "#000",
          }}
        />
      </ScrollUp>
    </>
  );
}

export default Home;
